import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const GetHigherAdvance = ({
  maxApprovedAmount,
}: {
  maxApprovedAmount: string;
}) => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'getHigherAdvanceStrings',
  });

  return (
    <View>
      <BodyBaseText numberOfLines={0} style={styles.title}>
        {translatedText('description')}
      </BodyBaseText>
      <ListItem
        primaryCopy={translatedText('bullets.first', {
          qualifiedAmount: maxApprovedAmount,
        })}
        showsChevron={false}
        leadingAccessory={{
          id: 'FLASH_ON_within_minutes',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'FLASH_ON',
          },
        }}
      />

      <ListItem
        primaryCopy={translatedText('bullets.second')}
        showsChevron={false}
        leadingAccessory={{
          id: 'DOWNLOAD',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'DOWNLOAD',
          },
        }}
      />

      <ListItem
        primaryCopy={translatedText('bullets.third')}
        showsChevron={false}
        leadingAccessory={{
          id: 'Clock',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'CLOCK',
          },
        }}
      />

      <BodyXSText style={styles.termsApply} numberOfLines={0}>
        {translatedText('disclaimerText', {
          qualifiedAmount: maxApprovedAmount,
        })}
      </BodyXSText>
    </View>
  );
};

const styles = StyleSheet.create({
  termsApply: {
    color: theme.color.text.secondary,
    padding: theme.spacing.m,
  },
  title: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default GetHigherAdvance;
